import type { FC } from 'react';
import type { SelectProps } from 'antd/lib/select';
import { Select } from 'antd';
import type { Period } from '@enmon/commons/lib/enmon';
import { periodOptions } from 'common/period';
import { filterOption } from '../utils/filterOption';

export interface PeriodSelectProps extends SelectProps<Period> {
  onChange?: (value: Period | null) => void;
}

export const PeriodSelect: FC<PeriodSelectProps> = ({ onChange, options = periodOptions, ...propsToPass }) => (
  <Select<Period>
    filterOption={filterOption}
    options={options}
    onSelect={(id?: Period) => onChange?.(id)}
    {...propsToPass}
  />
);
